import { withTheme } from '../../core/ThemeProvider';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import getFontFamily from '../../helpers/getFontFamily';
var getContentStyle = function getContentStyle(level) {
  switch (level) {
    case 0:
      return "counter(section) '. '";
    case 2:
      return "'(' counter(section, lower-alpha) ') '";
    case 3:
      return "'(' counter(section, lower-roman) ') '";
    default:
      return "counters(section, '.') ' '";
  }
};
var bodyLineHeights = {
  "default": 1.75,
  compact: 1.5,
  medium: 1.3
};
var fontWeights = {
  thin: 'thin',
  regular: 'regular',
  bold: 'bold'
};
var fontFamilyType = {
  primary: 'primary',
  secondary: 'secondary'
};
var typeReset = {
  marginTop: 0,
  marginBottom: 0,
  fontWeight: 'unset',
  letterSpacing: 0,
  textRendering: 'optimizeLegibility',
  '-webkit-font-smoothing': 'antialiased'
};
var NumberListItem = withTheme(styled.li.withConfig({
  displayName: "NumberedListItem__NumberListItem",
  componentId: "sc-1oxqrl8-0"
})(["", " ", " padding-top:", "px;color:", ";display:table;&::before{display:table-cell;", " padding-right:", "px;counter-increment:", ";content:", ";}"], function (_ref) {
  var _coreTheme$text, _coreTheme$text2, _coreTheme$text2$body;
  var coreTheme = _ref.coreTheme;
  return Object.assign({}, typeReset, responsiveStyles({
    fontSize: [16, 16, 16, 18, 18]
  }, coreTheme), {
    fontFamily: getFontFamily({
      fontFamilyType: ((_coreTheme$text = coreTheme.text) === null || _coreTheme$text === void 0 ? void 0 : _coreTheme$text.fontFamilyType) || fontFamilyType.secondary,
      fontWeight: fontWeights.regular,
      theme: coreTheme,
      typePreset: 'body'
    }),
    fontWeight: ((_coreTheme$text2 = coreTheme.text) === null || _coreTheme$text2 === void 0 ? void 0 : (_coreTheme$text2$body = _coreTheme$text2.body) === null || _coreTheme$text2$body === void 0 ? void 0 : _coreTheme$text2$body.fontWeight) || '',
    lineHeight: bodyLineHeights["default"],
    letterSpacing: 0.18
  });
}, function (_ref2) {
  var _coreTheme$text3, _coreTheme$text4;
  var coreTheme = _ref2.coreTheme;
  return coreTheme !== null && coreTheme !== void 0 && (_coreTheme$text3 = coreTheme.text) !== null && _coreTheme$text3 !== void 0 && _coreTheme$text3.body ? responsiveStyles(coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$text4 = coreTheme.text) === null || _coreTheme$text4 === void 0 ? void 0 : _coreTheme$text4.body, coreTheme) : {};
}, function (_ref3) {
  var _coreTheme$numberList;
  var coreTheme = _ref3.coreTheme;
  return coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$numberList = coreTheme.numberList) === null || _coreTheme$numberList === void 0 ? void 0 : _coreTheme$numberList.paddingTop;
}, function (_ref4) {
  var _coreTheme$numberList2;
  var coreTheme = _ref4.coreTheme;
  return coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$numberList2 = coreTheme.numberList) === null || _coreTheme$numberList2 === void 0 ? void 0 : _coreTheme$numberList2.colourText;
}, function (_ref5) {
  var _coreTheme$numberList3, _coreTheme$numberList4;
  var coreTheme = _ref5.coreTheme,
    simple = _ref5.simple,
    level = _ref5.level;
  return responsiveStyles({
    width: simple ? coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$numberList3 = coreTheme.numberList) === null || _coreTheme$numberList3 === void 0 ? void 0 : _coreTheme$numberList3.simpleWidth : level === 3 ? 32 : coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$numberList4 = coreTheme.numberList) === null || _coreTheme$numberList4 === void 0 ? void 0 : _coreTheme$numberList4.complexWidth
  }, coreTheme);
}, function (_ref6) {
  var _coreTheme$numberList5;
  var coreTheme = _ref6.coreTheme;
  return coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$numberList5 = coreTheme.numberList) === null || _coreTheme$numberList5 === void 0 ? void 0 : _coreTheme$numberList5.paddingRight;
}, function (_ref7) {
  var counterIncrement = _ref7.counterIncrement;
  return counterIncrement ? "section ".concat(counterIncrement) : 'section';
}, function (_ref8) {
  var level = _ref8.level;
  return getContentStyle(level);
}));
NumberListItem.propTypes = {
  coreTheme: PropTypes.object.isRequired,
  simple: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  counterIncrement: PropTypes.number
};
Number.defaultProps = {
  counterIncrement: null
};
export default NumberListItem;